import '@babel/polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import 'sanitize.css/sanitize.css';
import './style.css';
import ErrorBoundary from './ErrorBoundary';
// import './styles/layout/base.scss';
import history from './utils/history';
import App from './containers/App';
import LanguageProvider from './containers/LanguageProvider';
import store from './composition/configureStore';
import { translationMessages } from './i18n';
// import ChatWithDesk from './containers/ChatBox';
const MOUNT_NODE = document.getElementById('app');

const render = messages => {
  ReactDOM.render(
    <Provider store={store}>
      <LanguageProvider messages={messages} history={history}>
        <Router history={history}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
          {/* <ChatWithDesk /> */}
        </Router>
      </LanguageProvider>
    </Provider>,
    MOUNT_NODE,
  );
};

if (module.hot) {
  module.hot.accept(['./i18n', 'containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

if (!window.Intl) {
  new Promise(resolve => {
    resolve(import('intl'));
  })
    .then(() => Promise.all([import('intl/locale-data/jsonp/en.js'), import('intl/locale-data/jsonp/ar-SA.js')]))
    .then(() => render(translationMessages))
    .catch(err => {
      throw err;
    });
} else {
  render(translationMessages);
}

if (process.env.NODE_ENV === 'production') {
  require('offline-plugin/runtime').install();
}
